// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenu-cls1__e58c1d300b2eff5b910e{/*!*/}.AccountMenu-cls2__a195bd2d8951d8097f4f{display:flex;flex-direction:column;align-items:flex-start;grid-gap:8px;gap:8px;grid-gap:var(--spacing-xs-8, 8px);gap:var(--spacing-xs-8, 8px);align-self:stretch;padding:0;margin:0;list-style:none}.AccountMenu-cls2__a195bd2d8951d8097f4f>li{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenu-cls1__e58c1d300b2eff5b910e",
	"cls2": "AccountMenu-cls2__a195bd2d8951d8097f4f AccountMenu-cls1__e58c1d300b2eff5b910e"
};
export default ___CSS_LOADER_EXPORT___;
